import React, { useEffect } from 'react';
import './News.css';
import usePageTitle from '../hooks/usePageTitle';
import NewsletterSignup from '../components/NewsletterSignup';
import LatestNews from '../components/LatestNews';
import { newsArticles } from '../data/newsArticles';

const News: React.FC = () => {
  usePageTitle('News - The Kults');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="news-page">
      <section className="news-hero">
        <div className="container">
          <h1>NEWS</h1>
          <p>Stay updated with the latest news and announcements from The Kults</p>
        </div>
      </section>

      <section className="newsletter-section" style={{ marginTop: '10px' }}>
        <div className="container">
          <NewsletterSignup
            title="Never Miss an Update"
            description="Subscribe to get the latest news, tour announcements, and exclusive content from The Kults."
            variant="compact"
          />
        </div>
      </section>

      <LatestNews showViewAll={false} maxArticles={newsArticles.length} />
    </div>
  );
};

export default News;
